const SharedSubscriptionConstants = require("../subscriptions/SharedSubscriptionConstants");
const SubscriptionStatuses = SharedSubscriptionConstants.statuses;

const SharedUserUtilities = {
  isUserPremium(subscription) {
    return subscription.status === SubscriptionStatuses.ACTIVE;
  },
};

module.exports = SharedUserUtilities;
